import { ref as n, watch as o } from "vue";
function a(r, u, i) {
  if (!u)
    return r;
  const e = n(r.value);
  let t = null;
  return o(r, (l) => {
    t !== null && window.clearTimeout(t), l === !0 ? i && !i.value ? e.value = !0 : t = window.setTimeout(() => {
      e.value = !0;
    }, u) : e.value = !1;
  }), e;
}
export {
  a as useDeferredTrue
};
